// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Titillium+Web:wght@200;300;400;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /*Fonts*/
  --font-titillium: "Titillium Web", sans-serif;
  /*Colors*/
  --primary-text: #333333;
  --secondary-text: #808080;
  --text-white: #ffffff;
  --primary-color: #0079c1;
  --secondary-color: #00457c;
  --bg-danger: #ffece3;
  --text-danger: #ff7f41;
  --bg-success: #dbf8f4;
  --text-success: #11d1b7;
  --bg-info: #bfddf0;
  --text-info: #0079c1;
  --bg-warning: #fff6e7;
  --text-warning: #ffc061;
  --btn-success: #11d1b7;
  --btn-success-hover: #0eb29c;
  --btn-info: #0079c1;
  --btn-info-hover: #2d65cd;
  --btn-danger:#f06548;
  --btn-danger-hover:#cc563d;
  /*Breakpoints*/
}

*, *:before, *:after {
  box-sizing: border-box;
}

html, body, div, span, object, iframe, figure, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, code, em, img, small, strike, strong, sub, sup, tt, b, u, i, ol, ul, li, fieldset, form, label, table, caption, tbody, tfoot, thead, tr, th, td, main, canvas, embed, footer, header, nav, section, video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  text-size-adjust: none;
}

footer, header, nav, section, main {
  display: block;
}

body {
  line-height: 1;
}

ol, ul {
  list-style: none;
}

blockquote, q {
  quotes: none;
}

blockquote:before, blockquote:after, q:before, q:after {
  content: "";
  content: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

input {
  -webkit-appearance: none;
  border-radius: 0;
  margin-bottom: 1em;
}

label {
  color: #333333;
  padding-bottom: 0.5em;
}

html, body {
  font-family: var(--font-titillium);
  font-size: 1em;
  color: #fff;
  background-color: #f7f7f9;
}

.bg-header {
  background-color: var(--secondary-color);
}

.logo-var {
  border-left: 1px solid #ffffff;
  padding: 0.25em;
}

.table-shadow {
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
}

.table-column-name {
  text-transform: uppercase;
  font-weight: 600;
}

.bg-danger-ipb {
  background-color: var(--bg-danger);
}

.text-danger-ipb {
  color: var(--text-danger);
}

.badge-danger-ipb {
  background-color: var(--bg-danger);
  color: var(--text-danger);
  text-transform: uppercase;
  font-size: 1em;
  text-align: center;
}

.bg-success-ipb {
  background-color: var(--bg-success);
}

.text-success-ipb {
  color: var(--text-success);
}

.badge-success-ipb {
  background-color: var(--bg-success);
  color: var(--text-success);
  text-transform: uppercase;
  font-size: 1em;
}

.bg-info-ipb {
  background-color: var(--bg-info);
}

.text-info-ipb {
  color: var(--text-info);
}

.badge-info-ipb {
  background-color: var(--bg-info);
  color: var(--text-info);
  text-transform: uppercase;
  font-size: 1em;
}

.bg-warning-ipb {
  background-color: var(--bg-warning);
}

.text-warning-ipb {
  color: var(--text-warning);
}

.badge-warning-ipb {
  background-color: var(--bg-warning);
  color: var(--text-warning);
  text-transform: uppercase;
  font-size: 1em;
}

.btn-paynow-ipb {
  background-color: var(--btn-success);
  color: #ffffff;
  border: none;
  border-radius: 4px;
  font-size: 1em;
  font-weight: 600;
  text-transform: uppercase;
  padding: 0.35em 0.65em;
}

.btn-paynow-ipb:hover {
  background-color: var(--btn-success-hover);
}

.btn-downloadpdf-ipb {
  background-color: var(--btn-info);
  color: #ffffff;
  border: none;
  border-radius: 4px;
  font-size: 1em;
  font-weight: 600;
  padding: 0.35em 0.65em;
}

.btn-downloadpdf-ipb:hover {
  background-color: var(--btn-info-hover);
}

.bg-primary {
  background-color: var(--primary-color);
}

.btn-primary {
  background-color: var(--btn-info);
  border: 1px solid var(--btn-info);
}

.btn-primary:hover {
  background-color: var(--btn-info-hover);
  border: 1px solid var(--btn-info-hover);
}

.btn-danger {
  background-color: var(--btn-danger);
  border: 1px solid var(--btn-danger);
}

.btn-danger:hover {
  background-color: var(--btn-danger-hover);
  border: 1px solid var(--btn-danger-hover);
}

.btn-success {
  background-color: var(--btn-success);
  border: 1px solid var(--btn-success);
  font-weight: 600;
}

.btn-success:hover {
  background-color: var(--btn-success-hover);
  border: 1px solid var(--btn-success-hover);
}

.btn-success-ipb {
  background-color: var(--btn-success);
  border: 1px solid var(--btn-success);
  color: #ffffff;
}

.btn-success-ipb:hover {
  background-color: var(--btn-success-hover);
  border: 1px solid var(--btn-success-hover);
}

.main-title {
  font-size: 1.5em;
  padding-bottom: 1em;
}

.filters-block input {
  margin-bottom: 0;
  width: 150px !important;
}

.modal-title {
  font-size: 1.5em;
}

.fs-12 {
  font-size: 12px;
}

.button-payment {
  font-weight: 600;
}

.body-login {
  width: 100%;
  min-height: 100vh;
}
.body-login .container-login {
  width: 100%;
  max-width: 420px;
  min-height: 400px;
}
.body-login .container-login img {
  width: 50%;
  padding-bottom: 0.5em;
}
.body-login .container-login .login {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 1.5rem;
  background-color: #ffffff;
  border-radius: 4px;
  color: var(--primary-text);
  font-weight: 600;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
}
.body-login .container-login .login .dropdown-toggle {
  color: var(--secondary-text);
  font-size: 1em;
  background-color: #ffffff;
  border: 1px solid #ffffff;
  margin-bottom: 2em;
}
.body-login .container-login .login form {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  flex-grow: 1;
  padding-bottom: 1rem;
}
.body-login .container-login .login form input[type=text], .body-login .container-login .login form input[type=password] {
  font-family: var(--font-titillium);
  font-size: 1rem;
  padding: 0.6rem 0.9rem;
  border-radius: 4px;
  border: 1px solid #c6c6c6;
  margin-top: 0.3rem;
  margin-bottom: 1.8rem;
}
.body-login .container-login .login form input[type=text]:focus, .body-login .container-login .login form input[type=password]:focus {
  border-color: 1px solid var(--primary-color);
}
.body-login .container-login .login form input[type=text]:focus-visible, .body-login .container-login .login form input[type=password]:focus-visible {
  border-color: 1px solid var(--primary-color);
}
.body-login .container-login .login form label {
  margin-top: 0rem;
  margin-bottom: 0rem;
}
.body-login .container-login .login form button {
  padding: 0.5em;
  background-color: var(--primary-color);
  border: 1px solid var(--primary-color);
  color: var(--text-white);
  border-radius: 4px;
  font-weight: 600;
  padding: 0.8rem;
  margin-top: 1rem;
  line-height: var(--bs-body-line-height);
}
.body-login .container-login .login form button:hover {
  background-color: var(--secondary-color);
  border: 1px solid var(--secondary-color);
}
.body-login .container-login .login form p {
  padding-bottom: 2.5em;
  text-align: center;
}
.body-login .container-login .login .errmsg {
  background-color: lightpink;
  color: firebrick;
  font-weight: bold;
  padding: 0.5rem;
  margin-bottom: 0.5rem;
}
.body-login .container-login .login .offscreen {
  position: absolute;
  left: -9999px;
}
.body-login .container-login .login .link {
  color: var(--secondary-text);
  text-decoration: none;
  text-align: right;
  font-weight: 400;
}
.body-login .container-login .login .link:hover {
  color: var(--secondary-color);
  cursor: pointer;
}

.loading-full-screen {
  position: fixed;
  top: -10%;
  left: 0;
  z-index: 999;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  scale: 1.5;
}

.btn-paynow {
  display: inline-block;
  padding: 0.0625rem 0.3125rem;
  font-size: 0.75rem;
  line-height: 1.5;
  border-radius: 0.2rem;
  white-space: nowrap;
  color: #fff;
  background-color: #3aadaa;
  border-color: rgba(0, 0, 0, 0.2);
  transition: transform 0.2s;
}
.btn-paynow:hover {
  transform: scale(1.1);
  cursor: pointer;
  filter: brightness(1.2);
}`, "",{"version":3,"sources":["webpack://./src/scss/abstracts/_variables.scss","webpack://./src/scss/index.scss","webpack://./src/scss/base/_reset.scss","webpack://./src/scss/base/_base.scss","webpack://./src/scss/components/_login.scss","webpack://./src/scss/components/_loadingFullScreen.scss","webpack://./src/scss/components/_buttonPayNow.scss"],"names":[],"mappings":"AAGA;EACI,QAAA;EAEA,6CAAA;EAEA,SAAA;EAEA,uBAAA;EACA,yBAAA;EACA,qBAAA;EACA,wBAAA;EACA,0BAAA;EAEA,oBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,kBAAA;EACA,oBAAA;EACA,qBAAA;EACA,uBAAA;EAEA,sBAAA;EACA,4BAAA;EACA,mBAAA;EACA,yBAAA;EACA,oBAAA;EACA,0BAAA;EAEA,cAAA;ACPJ;;ACzBA;EACI,sBAAA;AD4BJ;;ACzBA;EACI,SAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,wBAAA;EACA,kCAAA;EACA,mCAAA;EACA,sBAAA;AD4BJ;;ACzBA;EACI,cAAA;AD4BJ;;ACzBA;EACI,cAAA;AD4BJ;;ACzBA;EACI,gBAAA;AD4BJ;;ACzBA;EACI,YAAA;AD4BJ;;ACzBA;EACI,WAAA;EACA,aAAA;AD4BJ;;ACzBA;EACI,yBAAA;EACA,iBAAA;AD4BJ;;ACzBA;EACI,wBAAA;EACA,gBAAA;EACA,kBAAA;AD4BJ;;ACxBA;EACI,cAAA;EACA,qBAAA;AD2BJ;;AE9EA;EACI,kCAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;AFiFJ;;AE9EA;EACI,wCAAA;AFiFJ;;AE9EA;EACI,8BAAA;EACA,eAAA;AFiFJ;;AE9EC;EACG,iDAAA;AFiFJ;;AE9EC;EACG,yBAAA;EACA,gBAAA;AFiFJ;;AE9EC;EACG,kCAAA;AFiFJ;;AE7EC;EACG,yBAAA;AFgFJ;;AE7EC;EACG,kCAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;AFgFJ;;AE7EC;EACG,mCAAA;AFgFJ;;AE7EC;EACG,0BAAA;AFgFJ;;AE7EA;EACI,mCAAA;EACA,0BAAA;EACA,yBAAA;EACA,cAAA;AFgFJ;;AE7EA;EACI,gCAAA;AFgFJ;;AE7EC;EACG,uBAAA;AFgFJ;;AE7EA;EACI,gCAAA;EACA,uBAAA;EACA,yBAAA;EACA,cAAA;AFgFJ;;AE1EC;EACG,mCAAA;AF6EJ;;AE1EC;EACG,0BAAA;AF6EJ;;AE1EA;EACI,mCAAA;EACA,0BAAA;EACA,yBAAA;EACA,cAAA;AF6EJ;;AEzEC;EACG,oCAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;AF4EJ;;AEzEC;EACG,0CAAA;AF4EJ;;AEzEC;EACG,iCAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;AF4EJ;;AEzEC;EACG,uCAAA;AF4EJ;;AEzEA;EACI,sCAAA;AF4EJ;;AExEA;EACI,iCAAA;EACA,iCAAA;AF2EJ;;AEvEA;EACA,uCAAA;EACI,uCAAA;AF0EJ;;AEvEA;EACI,mCAAA;EACA,mCAAA;AF0EJ;;AExEA;EACI,yCAAA;EACA,yCAAA;AF2EJ;;AEzEA;EACI,oCAAA;EACA,oCAAA;EACA,gBAAA;AF4EJ;;AE1EA;EACI,0CAAA;EACA,0CAAA;AF6EJ;;AEzEA;EACI,oCAAA;EACA,oCAAA;EACA,cAAA;AF4EJ;;AE1EA;EACI,0CAAA;EACA,0CAAA;AF6EJ;;AE1EA;EACI,gBAAA;EACA,mBAAA;AF6EJ;;AE1EA;EACI,gBAAA;EACA,uBAAA;AF6EJ;;AE1EA;EACI,gBAAA;AF6EJ;;AE3EA;EACI,eAAA;AF8EJ;;AE3EA;EACI,gBAAA;AF8EJ;;AGrQA;EACI,WAAA;EACA,iBAAA;AHwQJ;AGnQI;EACI,WAAA;EACA,gBAAA;EACA,iBAAA;AHqQR;AGnQQ;EACI,UAAA;EACA,qBAAA;AHqQZ;AGjQQ;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,0BAAA;EACA,gBAAA;EACA,iDAAA;AHmQZ;AGhQQ;EACI,4BAAA;EACA,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;AHkQZ;AG/PY;EACI,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,YAAA;EACA,oBAAA;AHiQhB;AG/PgB;EACI,kCAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;AHiQpB;AG/PiB;EACG,4CAAA;AHiQpB;AG/PiB;EACG,4CAAA;AHiQpB;AG9PgB;EACI,gBAAA;EACA,mBAAA;AHgQpB;AG7PgB;EACG,cAAA;EACA,sCAAA;EACA,sCAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,uCAAA;AH+PnB;AG5PgB;EACG,wCAAA;EACA,wCAAA;AH8PnB;AG3PgB;EACI,qBAAA;EACA,kBAAA;AH6PpB;AGtPY;EACI,2BAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;AHwPhB;AGrPY;EACI,kBAAA;EACA,aAAA;AHuPhB;AGpPY;EACI,4BAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;AHsPhB;AGnPY;EACI,6BAAA;EACA,eAAA;AHqPhB;;AIxWA;EACI,eAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AJ2WJ;;AKrXA;EACI,qBAAA;EACA,4BAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,yBAAA;EACA,gCAAA;EACA,0BAAA;ALwXJ;AKtXI;EACI,qBAAA;EACA,eAAA;EACA,uBAAA;ALwXR","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Titillium+Web:wght@200;300;400;600;700&display=swap');\n\n\n:root{\n    /*Fonts*/\n    \n    --font-titillium: 'Titillium Web', sans-serif;\n\n    /*Colors*/\n\n    --primary-text: #333333;\n    --secondary-text: #808080;\n    --text-white: #ffffff;\n    --primary-color: #0079c1;\n    --secondary-color: #00457c;\n\n    --bg-danger: #ffece3;\n    --text-danger: #ff7f41;\n    --bg-success: #dbf8f4;\n    --text-success: #11d1b7;\n    --bg-info: #bfddf0;\n    --text-info: #0079c1;\n    --bg-warning: #fff6e7;\n    --text-warning: #ffc061;\n\n    --btn-success: #11d1b7;\n    --btn-success-hover: #0eb29c;\n    --btn-info: #0079c1;\n    --btn-info-hover: #2d65cd;\n    --btn-danger:#f06548;\n    --btn-danger-hover:#cc563d;\n\n    /*Breakpoints*/\n}","@import url(\"https://fonts.googleapis.com/css2?family=Titillium+Web:wght@200;300;400;600;700&display=swap\");\n:root {\n  /*Fonts*/\n  --font-titillium: \"Titillium Web\", sans-serif;\n  /*Colors*/\n  --primary-text: #333333;\n  --secondary-text: #808080;\n  --text-white: #ffffff;\n  --primary-color: #0079c1;\n  --secondary-color: #00457c;\n  --bg-danger: #ffece3;\n  --text-danger: #ff7f41;\n  --bg-success: #dbf8f4;\n  --text-success: #11d1b7;\n  --bg-info: #bfddf0;\n  --text-info: #0079c1;\n  --bg-warning: #fff6e7;\n  --text-warning: #ffc061;\n  --btn-success: #11d1b7;\n  --btn-success-hover: #0eb29c;\n  --btn-info: #0079c1;\n  --btn-info-hover: #2d65cd;\n  --btn-danger:#f06548;\n  --btn-danger-hover:#cc563d;\n  /*Breakpoints*/\n}\n\n*, *:before, *:after {\n  box-sizing: border-box;\n}\n\nhtml, body, div, span, object, iframe, figure, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, code, em, img, small, strike, strong, sub, sup, tt, b, u, i, ol, ul, li, fieldset, form, label, table, caption, tbody, tfoot, thead, tr, th, td, main, canvas, embed, footer, header, nav, section, video {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font: inherit;\n  vertical-align: baseline;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  text-size-adjust: none;\n}\n\nfooter, header, nav, section, main {\n  display: block;\n}\n\nbody {\n  line-height: 1;\n}\n\nol, ul {\n  list-style: none;\n}\n\nblockquote, q {\n  quotes: none;\n}\n\nblockquote:before, blockquote:after, q:before, q:after {\n  content: \"\";\n  content: none;\n}\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\ninput {\n  -webkit-appearance: none;\n  border-radius: 0;\n  margin-bottom: 1em;\n}\n\nlabel {\n  color: #333333;\n  padding-bottom: 0.5em;\n}\n\nhtml, body {\n  font-family: var(--font-titillium);\n  font-size: 1em;\n  color: #fff;\n  background-color: #f7f7f9;\n}\n\n.bg-header {\n  background-color: var(--secondary-color);\n}\n\n.logo-var {\n  border-left: 1px solid #ffffff;\n  padding: 0.25em;\n}\n\n.table-shadow {\n  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n}\n\n.table-column-name {\n  text-transform: uppercase;\n  font-weight: 600;\n}\n\n.bg-danger-ipb {\n  background-color: var(--bg-danger);\n}\n\n.text-danger-ipb {\n  color: var(--text-danger);\n}\n\n.badge-danger-ipb {\n  background-color: var(--bg-danger);\n  color: var(--text-danger);\n  text-transform: uppercase;\n  font-size: 1em;\n  text-align: center;\n}\n\n.bg-success-ipb {\n  background-color: var(--bg-success);\n}\n\n.text-success-ipb {\n  color: var(--text-success);\n}\n\n.badge-success-ipb {\n  background-color: var(--bg-success);\n  color: var(--text-success);\n  text-transform: uppercase;\n  font-size: 1em;\n}\n\n.bg-info-ipb {\n  background-color: var(--bg-info);\n}\n\n.text-info-ipb {\n  color: var(--text-info);\n}\n\n.badge-info-ipb {\n  background-color: var(--bg-info);\n  color: var(--text-info);\n  text-transform: uppercase;\n  font-size: 1em;\n}\n\n.bg-warning-ipb {\n  background-color: var(--bg-warning);\n}\n\n.text-warning-ipb {\n  color: var(--text-warning);\n}\n\n.badge-warning-ipb {\n  background-color: var(--bg-warning);\n  color: var(--text-warning);\n  text-transform: uppercase;\n  font-size: 1em;\n}\n\n.btn-paynow-ipb {\n  background-color: var(--btn-success);\n  color: #ffffff;\n  border: none;\n  border-radius: 4px;\n  font-size: 1em;\n  font-weight: 600;\n  text-transform: uppercase;\n  padding: 0.35em 0.65em;\n}\n\n.btn-paynow-ipb:hover {\n  background-color: var(--btn-success-hover);\n}\n\n.btn-downloadpdf-ipb {\n  background-color: var(--btn-info);\n  color: #ffffff;\n  border: none;\n  border-radius: 4px;\n  font-size: 1em;\n  font-weight: 600;\n  padding: 0.35em 0.65em;\n}\n\n.btn-downloadpdf-ipb:hover {\n  background-color: var(--btn-info-hover);\n}\n\n.bg-primary {\n  background-color: var(--primary-color);\n}\n\n.btn-primary {\n  background-color: var(--btn-info);\n  border: 1px solid var(--btn-info);\n}\n\n.btn-primary:hover {\n  background-color: var(--btn-info-hover);\n  border: 1px solid var(--btn-info-hover);\n}\n\n.btn-danger {\n  background-color: var(--btn-danger);\n  border: 1px solid var(--btn-danger);\n}\n\n.btn-danger:hover {\n  background-color: var(--btn-danger-hover);\n  border: 1px solid var(--btn-danger-hover);\n}\n\n.btn-success {\n  background-color: var(--btn-success);\n  border: 1px solid var(--btn-success);\n  font-weight: 600;\n}\n\n.btn-success:hover {\n  background-color: var(--btn-success-hover);\n  border: 1px solid var(--btn-success-hover);\n}\n\n.btn-success-ipb {\n  background-color: var(--btn-success);\n  border: 1px solid var(--btn-success);\n  color: #ffffff;\n}\n\n.btn-success-ipb:hover {\n  background-color: var(--btn-success-hover);\n  border: 1px solid var(--btn-success-hover);\n}\n\n.main-title {\n  font-size: 1.5em;\n  padding-bottom: 1em;\n}\n\n.filters-block input {\n  margin-bottom: 0;\n  width: 150px !important;\n}\n\n.modal-title {\n  font-size: 1.5em;\n}\n\n.fs-12 {\n  font-size: 12px;\n}\n\n.button-payment {\n  font-weight: 600;\n}\n\n.body-login {\n  width: 100%;\n  min-height: 100vh;\n}\n.body-login .container-login {\n  width: 100%;\n  max-width: 420px;\n  min-height: 400px;\n}\n.body-login .container-login img {\n  width: 50%;\n  padding-bottom: 0.5em;\n}\n.body-login .container-login .login {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  padding: 1.5rem;\n  background-color: #ffffff;\n  border-radius: 4px;\n  color: var(--primary-text);\n  font-weight: 600;\n  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n}\n.body-login .container-login .login .dropdown-toggle {\n  color: var(--secondary-text);\n  font-size: 1em;\n  background-color: #ffffff;\n  border: 1px solid #ffffff;\n  margin-bottom: 2em;\n}\n.body-login .container-login .login form {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n  flex-grow: 1;\n  padding-bottom: 1rem;\n}\n.body-login .container-login .login form input[type=text], .body-login .container-login .login form input[type=password] {\n  font-family: var(--font-titillium);\n  font-size: 1rem;\n  padding: 0.6rem 0.9rem;\n  border-radius: 4px;\n  border: 1px solid #c6c6c6;\n  margin-top: 0.3rem;\n  margin-bottom: 1.8rem;\n}\n.body-login .container-login .login form input[type=text]:focus, .body-login .container-login .login form input[type=password]:focus {\n  border-color: 1px solid var(--primary-color);\n}\n.body-login .container-login .login form input[type=text]:focus-visible, .body-login .container-login .login form input[type=password]:focus-visible {\n  border-color: 1px solid var(--primary-color);\n}\n.body-login .container-login .login form label {\n  margin-top: 0rem;\n  margin-bottom: 0rem;\n}\n.body-login .container-login .login form button {\n  padding: 0.5em;\n  background-color: var(--primary-color);\n  border: 1px solid var(--primary-color);\n  color: var(--text-white);\n  border-radius: 4px;\n  font-weight: 600;\n  padding: 0.8rem;\n  margin-top: 1rem;\n  line-height: var(--bs-body-line-height);\n}\n.body-login .container-login .login form button:hover {\n  background-color: var(--secondary-color);\n  border: 1px solid var(--secondary-color);\n}\n.body-login .container-login .login form p {\n  padding-bottom: 2.5em;\n  text-align: center;\n}\n.body-login .container-login .login .errmsg {\n  background-color: lightpink;\n  color: firebrick;\n  font-weight: bold;\n  padding: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n.body-login .container-login .login .offscreen {\n  position: absolute;\n  left: -9999px;\n}\n.body-login .container-login .login .link {\n  color: var(--secondary-text);\n  text-decoration: none;\n  text-align: right;\n  font-weight: 400;\n}\n.body-login .container-login .login .link:hover {\n  color: var(--secondary-color);\n  cursor: pointer;\n}\n\n.loading-full-screen {\n  position: fixed;\n  top: -10%;\n  left: 0;\n  z-index: 999;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  scale: 1.5;\n}\n\n.btn-paynow {\n  display: inline-block;\n  padding: 0.0625rem 0.3125rem;\n  font-size: 0.75rem;\n  line-height: 1.5;\n  border-radius: 0.2rem;\n  white-space: nowrap;\n  color: #fff;\n  background-color: #3aadaa;\n  border-color: rgba(0, 0, 0, 0.2);\n  transition: transform 0.2s;\n}\n.btn-paynow:hover {\n  transform: scale(1.1);\n  cursor: pointer;\n  filter: brightness(1.2);\n}","*, *:before, *:after{\n    box-sizing: border-box;\n}\n  \nhtml, body, div, span, object, iframe, figure, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, code, em, img, small, strike, strong, sub, sup, tt, b, u, i, ol, ul, li, fieldset, form, label, table, caption, tbody, tfoot, thead, tr, th, td, main, canvas, embed, footer, header, nav, section, video{\n    margin: 0;\n    padding: 0;\n    border: 0;\n    font-size: 100%;\n    font: inherit;\n    vertical-align: baseline;\n    text-rendering: optimizeLegibility;\n    -webkit-font-smoothing: antialiased;\n    text-size-adjust: none;\n}\n  \nfooter, header, nav, section, main{\n    display: block;\n}\n  \nbody{\n    line-height: 1;\n}\n  \nol, ul{\n    list-style: none;\n}\n  \nblockquote, q{\n    quotes: none;\n}\n  \nblockquote:before, blockquote:after, q:before, q:after{\n    content: '';\n    content: none;\n}\n  \ntable{\n    border-collapse: collapse;\n    border-spacing: 0;\n}\n  \ninput{\n    -webkit-appearance: none;\n    border-radius: 0;\n    margin-bottom: 1em;\n\n}\n\nlabel {\n    color: #333333;\n    padding-bottom:.5em;\n}\n\n","html, body{\n    font-family: var(--font-titillium);\n    font-size: 1em;\n    color: #fff;\n    background-color: #f7f7f9;\n}\n\n.bg-header {\n    background-color: var(--secondary-color);\n}\n\n.logo-var {\n    border-left: 1px solid #ffffff;\n    padding: 0.25em;\n}\n\n .table-shadow{\n    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n }\n\n .table-column-name {\n    text-transform: uppercase;\n    font-weight: 600;\n }\n\n .bg-danger-ipb {\n    background-color: var(--bg-danger);\n\n }\n\n .text-danger-ipb {\n    color: var(--text-danger);\n }\n\n .badge-danger-ipb {\n    background-color: var(--bg-danger);\n    color: var(--text-danger);\n    text-transform: uppercase;\n    font-size:1em;\n    text-align: center;\n }\n\n .bg-success-ipb {\n    background-color: var(--bg-success);\n }\n\n .text-success-ipb {\n    color: var(--text-success);\n }\n\n.badge-success-ipb {\n    background-color: var(--bg-success);\n    color: var(--text-success);\n    text-transform: uppercase;\n    font-size:1em;\n }\n\n.bg-info-ipb {\n    background-color: var(--bg-info);\n }\n\n .text-info-ipb {\n    color: var(--text-info);\n }\n\n.badge-info-ipb {\n    background-color: var(--bg-info);\n    color: var(--text-info);\n    text-transform: uppercase;\n    font-size:1em;\n\n\n\n }\n\n .bg-warning-ipb {\n    background-color: var(--bg-warning);\n }\n\n .text-warning-ipb {\n    color: var(--text-warning);\n }\n\n.badge-warning-ipb {\n    background-color: var(--bg-warning);\n    color: var(--text-warning);\n    text-transform: uppercase;\n    font-size:1em;\n\n }\n\n .btn-paynow-ipb {\n    background-color: var(--btn-success);\n    color: #ffffff;\n    border:none;\n    border-radius: 4px;\n    font-size: 1em;\n    font-weight:600;\n    text-transform: uppercase;\n    padding: 0.35em 0.65em;\n }\n\n .btn-paynow-ipb:hover {\n    background-color: var(--btn-success-hover);\n }\n\n .btn-downloadpdf-ipb {\n    background-color: var(--btn-info);\n    color: #ffffff;\n    border:none;\n    border-radius: 4px;\n    font-size: 1em;\n    font-weight:600;\n    padding: 0.35em 0.65em;\n }\n\n .btn-downloadpdf-ipb:hover {\n    background-color: var(--btn-info-hover);\n }\n\n.bg-primary {\n    background-color: var(--primary-color); \n  \n}\n\n.btn-primary{\n    background-color: var(--btn-info); \n    border: 1px solid var(--btn-info);\n    \n}\n\n.btn-primary:hover{\nbackground-color: var(--btn-info-hover);\n    border: 1px solid var(--btn-info-hover);\n    \n}\n.btn-danger {\n    background-color: var(--btn-danger); \n    border: 1px solid var(--btn-danger);\n}\n.btn-danger:hover{\n    background-color: var(--btn-danger-hover); \n    border: 1px solid var(--btn-danger-hover);\n}\n.btn-success{\n    background-color: var(--btn-success); \n    border: 1px solid var(--btn-success);\n    font-weight:600;\n}\n.btn-success:hover{\n    background-color: var(--btn-success-hover); \n    border: 1px solid var(--btn-success-hover);\n}\n\n\n.btn-success-ipb{\n    background-color: var(--btn-success); \n    border: 1px solid var(--btn-success);\n    color: #ffffff;\n}\n.btn-success-ipb:hover{\n    background-color: var(--btn-success-hover); \n    border: 1px solid var(--btn-success-hover);\n}\n\n.main-title {\n    font-size: 1.5em;\n    padding-bottom: 1em;\n}\n\n.filters-block input {\n    margin-bottom:0;\n    width: 150px !important;\n}\n\n.modal-title {\n    font-size: 1.5em; \n}\n.fs-12 {\n    font-size:12px;\n}\n\n.button-payment {\n    font-weight:600;\n}",".body-login {\n    width: 100%;\n    min-height: 100vh;\n  \n\n\n\n    .container-login{\n        width: 100%;\n        max-width: 420px;\n        min-height: 400px;\n\n        img{\n            width:50%;\n            padding-bottom: 0.5em;\n            }\n\n\n        .login {\n            width: 100%;\n            display: flex;\n            flex-direction: column;\n            justify-content: flex-start;\n            padding: 1.5rem;\n            background-color: #ffffff;\n            border-radius:4px;\n            color: var(--primary-text);\n            font-weight:600;\n            box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n\n                \n        .dropdown-toggle{\n            color: var(--secondary-text);\n            font-size: 1em;\n            background-color:#ffffff;\n            border: 1px solid #ffffff;\n            margin-bottom:2em;\n            } \n\n            form{\n                display: flex;\n                flex-direction: column;\n                justify-content: space-evenly;\n                flex-grow: 1;\n                padding-bottom: 1rem;\n    \n                input[type='text'],input[type='password']{\n                    font-family: var(--font-titillium);\n                    font-size: 1rem;\n                    padding: .6rem .9rem;\n                    border-radius: 4px;\n                    border: 1px solid #c6c6c6;\n                    margin-top: 0.3rem;\n                    margin-bottom: 1.8rem;\n                }\n                 input[type='text']:focus,input[type='password']:focus{\n                    border-color: 1px solid var(--primary-color);\n                }\n                 input[type='text']:focus-visible,input[type='password']:focus-visible{\n                    border-color: 1px solid var(--primary-color);\n                }\n\n                label{\n                    margin-top: 0rem;\n                    margin-bottom:0rem;\n                }\n\n                button{\n                   padding: 0.5em;\n                   background-color: var(--primary-color);\n                   border: 1px solid var(--primary-color);\n                   color: var(--text-white);\n                   border-radius: 4px;\n                   font-weight: 600;\n                   padding: 0.8rem;\n                   margin-top: 1rem;\n                   line-height: var(--bs-body-line-height);  \n                }\n\n                button:hover{\n                   background-color: var(--secondary-color);\n                   border: 1px solid var(--secondary-color);\n                }\n\n                p{\n                    padding-bottom:2.5em;\n                    text-align: center;\n\n\n                }\n                \n            }\n\n            .errmsg {\n                background-color: lightpink;\n                color: firebrick;\n                font-weight: bold;\n                padding: 0.5rem;\n                margin-bottom: 0.5rem;\n            }\n\n            .offscreen {\n                position: absolute;\n                left: -9999px;\n            }\n            \n            .link{\n                color: var(--secondary-text);\n                text-decoration: none;\n                text-align:right;\n                font-weight:400;\n              }\n\n            .link:hover{\n                color: var(--secondary-color);\n                cursor: pointer;\n            }\n              \n        }\n    }\n}\n\n",".loading-full-screen{\n    position: fixed;\n    top: -10%; \n    left: 0; \n    z-index: 999;\n    width: 100vw; \n    height: 100vh;\n    background: rgba(0, 0, 0, 0.6);\n    display: flex;\n    align-items: center; \n    justify-content: center;\n    scale: 1.5;\n  }","\n.btn-paynow {\n    display: inline-block;\n    padding: 0.0625rem 0.3125rem;\n    font-size: 0.75rem;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    white-space: nowrap;\n    color: #fff;\n    background-color: #3aadaa;\n    border-color: rgba(0, 0, 0, 0.2);\n    transition: transform 0.2s;\n\n    &:hover {\n        transform: scale(1.1);\n        cursor: pointer;\n        filter: brightness(1.2);\n    }\n}\n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
